import { render, staticRenderFns } from "./GameRecord.vue?vue&type=template&id=a928ae5c&scoped=true"
import script from "./GameRecord.vue?vue&type=script&lang=js"
export * from "./GameRecord.vue?vue&type=script&lang=js"
import style0 from "./GameRecord.vue?vue&type=style&index=0&id=a928ae5c&prod&lang=css"
import style1 from "./GameRecord.vue?vue&type=style&index=1&id=a928ae5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a928ae5c",
  null
  
)

export default component.exports